export default "__VITE_ASSET__UO74eLqX__"